import {Bill} from "arteco-api-client-ts";
import {Tone} from "../../../../components/kit";

/** Etiquetas en español de facturación (#13893): lo que el API manda como enum, legible en pantalla. */

export const PAYMENT_METHOD_LABELS: Record<string, string> = {
	TRANSFERENCIA: "Transferencia",
	ADEUDO_SEPA: "Adeudo SEPA",
	CONFIRMING: "Confirming",
};

export const BUDGET_KIND_LABELS: Record<string, string> = {
	PROYECTO: "Proyecto",
	BOLSA: "Bolsa de horas",
	TM: "Time & Materials",
	CUOTA: "Cuota",
};

export const SEPA_MANDATE_LABELS: Record<string, { label: string, tone: Tone }> = {
	ACTIVO: {label: "Activo", tone: "success"},
	REVOCADO: {label: "Revocado", tone: "neutral"},
	CADUCADO: {label: "Caducado", tone: "warning"},
};

/** Vencida y sin cobrar. Una cobrada fuera de plazo ya no reclama nada. */
export const isBillOverdue = (bean: Bill): boolean => {
	if (bean.paymentDate || bean.doubtful || !bean.dueDate) {
		return false;
	}
	return bean.dueDate < new Date().toISOString().slice(0, 10);
};

/**
 * Estado de cobro de una factura, con el mismo orden de prioridad que el color que tenía la fecha
 * en el listado: incobrable, cobrada, adelantada, enviada y, si no, sin enviar.
 */
export const billStatus = (bean: Bill): { label: string, tone: Tone } => {
	if (bean.doubtful) {
		return {label: "Incobrable", tone: "error"};
	} else if (bean.paymentDate) {
		return {label: "Cobrada", tone: "success"};
	} else if (bean.advanceDate) {
		return {label: "Adelantada", tone: "info"};
	} else if (bean.sentDate) {
		return isBillOverdue(bean) ? {label: "Vencida", tone: "error"} : {label: "Enviada", tone: "warning"};
	}
	return {label: "Sin enviar", tone: "neutral"};
};
